import { createQuery } from 'react-query-kit';

import { buildFilterUrl } from 'support/helpers/urls/urls';
import portalSchema from 'support/types/schema-portal';
import { Filter } from 'components/ListTable/types';

import { fetchData } from '../../http/http';

export const STATS_QUERY_KEY = '/stats';
export type GetDashboardStatsResponse =
  portalSchema.paths['/v1/stats/dashboard']['get']['responses']['200']['content']['application/json'];

export type GetFailedTransactionsCountResponse =
  portalSchema.paths['/v1/stats/failed']['get']['responses']['200']['content']['application/json'];

export type GetConnectionsCountResponse =
  portalSchema.paths['/v1/stats/connections']['get']['responses']['200']['content']['application/json'];

export type GetInboxStatsResponse =
  portalSchema.paths['/v1/stats/inbox']['get']['responses']['200']['content']['application/json'];

export const useDashboardStats = createQuery<GetDashboardStatsResponse, { relatedPartnerId?: string }, Error>({
  primaryKey: `${STATS_QUERY_KEY}/dashboard`,
  queryFn: async ({ queryKey: [, variables] }) => {
    const queryParams = variables.relatedPartnerId ? `?relatedPartnerId=${variables.relatedPartnerId}` : '';
    const { data } = await fetchData<GetDashboardStatsResponse>('/v1/stats/dashboard' + queryParams);
    return data;
  },
});

export const useFailedTransactionsCount = createQuery<GetFailedTransactionsCountResponse, any, Error>({
  primaryKey: `${STATS_QUERY_KEY}/failed`,
  queryFn: async () => {
    const { data } = await fetchData<GetFailedTransactionsCountResponse>('/v1/stats/failed');
    return data;
  },
});

export const useInboxStats = createQuery<GetInboxStatsResponse, any, Error>({
  primaryKey: `${STATS_QUERY_KEY}/inbox`,
  queryFn: async () => {
    const { data } = await fetchData<GetInboxStatsResponse>('/v1/stats/inbox');
    return data;
  },
});

export const useConnectionsStats = createQuery<GetConnectionsCountResponse, { query?: Filter }, Error>({
  primaryKey: `${STATS_QUERY_KEY}/connections`,
  queryFn: async ({ queryKey: [, variables] }) => {
    const urlParams = buildFilterUrl({ filterValues: [], ...variables.query }, { forApiRequest: true });
    const { data } = await fetchData<GetConnectionsCountResponse>('/v1/stats/connections' + urlParams);
    return data;
  },
});
